import { NgModule } from '@angular/core';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatRippleModule } from '@angular/material/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import {MatGridListModule} from '@angular/material/grid-list';

const MatModules = [
  MatProgressSpinnerModule,
  MatButtonToggleModule,
  MatAutocompleteModule,
  MatSlideToggleModule,
  MatProgressBarModule,
  MatFormFieldModule,
  MatExpansionModule,
  MatSnackBarModule,
  MatGridListModule,
  MatCheckboxModule,
  MatTooltipModule,
  MatToolbarModule,
  MatSidenavModule,
  MatDialogModule,
  MatButtonModule,
  MatSelectModule,
  MatRippleModule,
  MatChipsModule,
  MatRadioModule,
  MatInputModule,
  MatCardModule,
  MatMenuModule,
  MatTabsModule,
  MatListModule,
  MatIconModule,
];

@NgModule({
  imports: MatModules,
  exports: MatModules
})
export class MaterialModule {}
